export default "__VITE_ASSET__00b0db74__"